import { defineMessages } from 'react-intl'

import { intl } from 'common/components/l10n/IntlGlobalProvider'

const messages = defineMessages({
  passengerTypeAdultMsg: {
    id: 'constants.adult',
    description: "Option for an 'adult' passenger type",
    defaultMessage: 'Adult',
  },
  passengerTypeSeniorMsg: {
    id: 'constants.senior',
    description: "Option for a 'senior' passenger type",
    defaultMessage: 'Senior',
  },
  passengerTypeYouthMsg: {
    id: 'constants.youth',
    description: "Option for a 'youth' passenger type",
    defaultMessage: 'Youth',
  },
})

export const getPassengerTypeAdultMsg = () => intl.formatMessage(messages.passengerTypeAdultMsg)

export const getPassengerTypeSeniorMsg = () => intl.formatMessage(messages.passengerTypeSeniorMsg)

export const getPassengerTypeYouthMsg = () => intl.formatMessage(messages.passengerTypeYouthMsg)
